import React from 'react';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TextField from 'components/TextField/TextField';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';
export default function TabelaListaGeradores({ items = [], remover, ficha, permissao, onChangeSequencia }) {
    //Ações da tabela
    const actions = [actionsTable.remover(remover)];

    //Cabeçalhos da tabela de geradores
    let headers = [
        { value: "CPF/CNPJ", objectValue: "cpfcnpj" },
        { value: "Regional", objectValue: "regional" },
        { value: "Fantasia", objectValue: "fantasia" },
        { value: "Modalidade", objectValue: "modalidade" },
        { value: "Endereço", objectValue: "endereco" },
        {
            value: "Sequência", objectValue: "sequencia", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => (
                    <TextField
                        disabled={permissao && permissao == "Editar" ? false : true}
                        value={items[dataIndex].sequencia}
                        onChange={(e) => onChangeSequencia(dataIndex, e.target.value)} />
                )
            }
        },

    ]

    if (ficha) {
        return <TabelaListagemFichas headers={headers} items={items} width={"100"} />
    }
    return (
        <TabelaListagem title='Lista de geradores' headers={headers} items={items} actions={actions} options={{ print: false, search: true, pagination: true }} />
    )
}